// auth
export const SET_USER_ERROR = "setUserError";
export const PURGE_AUTH = "purgeAuth";
export const SET_AUTH = "setAuth";

// region
export const SET_REGION = "setRegion";

// product
export const SET_AWS_ERROR = "setAWSError";
export const SET_AWS_PRODUCTS = "setAWSProducts";
export const SET_AWS_LOADING = "setAWSLoading";
export const SET_AWS_SEARCH_MULTISELECT = "setAWSSearchMultiselect";

// component
export const SET_COMPONENT_LOADING = "setComponentLoading";
export const SET_COMPONENT_ERROR = "setComponentError";
export const SET_COMPONENT_SUCCESS = "setComponentSuccess";
export const SET_COMPONENT = "setComponent";
export const REMOVE_COMPONENT = "removeComponent";
export const SET_INSTANCE_DESCRIPTION = "setInstanceDescription";

// componentInstance
export const SET_DATA_LOADING = "setAttributesLoading";
export const SET_SYNC_DATA_FETCH_LOADING = "setSyncDataFetchLoading";
export const SET_DATA_ERROR = "setAttributesError";
export const SET_DATA_SUCCESS = "setDataSuccess";
export const SET_BASIC_ATTRIBUTES = "setBasicAttributes";
export const SET_ADDITIONAL_ATTRIBUTES = "setAdditionalAttributes";
export const SET_ALL_ATTRIBUTES = "setAllAttributes";
export const SET_INSTANCE_INFO = "setInstanceInfo";
export const SET_SYNC_INSTANCE_INFO = "setSyncInstanceInfo";
export const REMOVE_INSTANCE_INFO = "removeInstanceInfo";
export const CLEAR_COMPONENT_INFO = "clearComponentInfo";
export const SET_SAVE_LOADING = "setSaveLoading";
export const SET_CREATE_LOADING = "setCreateLoading";
export const SET_SYNC_LOADING = "setSyncLoading";
export const SET_COPY_LOADING = "setCopyLoading";
export const SET_DELETE_LOADING = "setDeleteLoading";
export const SET_OPERATION_MODE = "setOperationMode";
export const RESET_OPERATION_MODE = "resetOperationMode";
export const SET_INSTANCE_SEARCH = "setInstanceSearch";
export const SET_INSTANCE_PAGE = "setInstancePage";
export const SET_GLOBAL_SEARCH_RESULT = "setGlobalSearchResult";
export const SET_GLOBAL_SEARCH_LOADING = "setGlobalSearchLoading";

// abi image slider
export const SET_SLIDE_INSTANCE = "setSlideInstance";
export const SET_SLIDE_ATTRIBUTES = "setSlideAttributes";
export const SET_SLIDE_LOADING = "setSlideLoading";
export const SET_SLIDER_CREATE_LOADING = "setSliderCreateLoading";
export const SET_SLIDER_UPDATE_LOADING = "setSliderUpdateLoading";
export const SET_SLIDER_COPY_LOADING = "setSliderCopyLoading";

// category
export const FETCH_CATEGORY_INFO = "fetchCategoryInfo";
export const FETCH_CATEGORY_SLUG_OPTIONS = "fetchCategorySlugOptions";
export const SET_CATEGORY_ERROR = "setCategoryError";
export const SET_CATEGORY_SUCCESS = "setCategorySuccess";
export const SET_CATEGORY_LOADING = "setCategoryLoading";
export const ADD_CATEGORY_ATTRIBUTES = "addCategoryAttributes";
export const SET_CATEGORY_OPERATION = "setCategoryOperation";
export const SET_CATEGORY_INSTANCE = "setCategoryInstance";
export const CLEAR_CATEGORY_INSTANCE = "clearCategoryInstance";
export const SET_CATEGORY_SEARCH = "setCategorySearch";
export const SET_CATEGORY_OPTIONS_SEARCH = "setCategoryOptionsSearch";
export const SET_CATEGORY_INSTANCE_PAGE = "setCategoryInstancePage";
export const SET_EXIST_CATEGORY = "setExistCategory";
export const SET_PREVIEW_URL = "setPreviewUrl";
export const SET_INTRO_INSTANCE_INFO = "setIntroInstanceInfo";
export const SET_INTRO_DATA_LOADING = "setIntroDataLoading";

// blog
export const SET_BLOG_ERROR = "setBlogError";
export const SET_BLOG_SUCCESS = "setBlogSuccess";
export const SET_BLOG_OPERATION = "setBlogOperation";
export const SET_BLOG_COMPONENT_ATTR = "setBlogComponentAttr";
export const SET_BLOG_COMPONENT_INSTANCE = "setBlogComponentInstance";
export const SET_BLOG_SELECTED_INSTANCE = "setBlogSelectedInstance";
export const SET_BLOG_COMPONENT_LOADING = "setBlogComponentLoading";
export const SET_BLOG_INSTANCE_LOADING = "setBlogInstanceLoading";
export const CLEAR_BLOG_COMPONENT_ATTR = "clearBlogComponentAttr";
export const CLEAR_BLOG_COMPONENT_LOADING = "clearBlogComponentLoading";
export const SET_INSTANCE_CREATE_LOADING = "setInstanceCreateLoading";
export const SET_INSTANCE_COPY_LOADING = "setInstanceCopyLoading";
export const SET_INSTANCE_EDIT_LOADING = "setInstanceEditLoading";
export const CLEAR_BLOG_SELECTED_INSTANCE = "clearBlogSelectedInstance";
export const DELETE_SELECTED_INSTANCE = "deleteSelectedInstance";
export const DELETE_COMPONENT_ATTRIBUTE = "deleteComponentAttribute";

// draft
export const SET_INSTANCE_DRAFT = "setInstanceDraft";
export const SET_DRAFT_MODE_STATUS = "setDraftModeStatus";
export const SET_DRAFT_SAVE_LOADING = "setDraftSaveLoading";
export const SET_DRAFT_CREATE_LOADING = "setDraftCreateLoading";
export const REMOVE_DRAFT_INFO = "removeDraftInfo";

// notice
export const SET_DELAY_MESSAGE = "setDelayMessage";
export const SET_DELAY_MESSAGE_LOADING = "setDelayMessageLoading";
export const SET_FETCH_DELAY_MESSAGE_LOADING = "setFetchDelayMessageLoading";
